import React, { useCallback } from 'react';
var isSelectingText = function () {
    var selection = window.getSelection();
    return selection && selection.toString().length > 0;
};
// Edit mode / Read Only mode handling
export var useEditModeToggle = function (disabled) {
    var _a = React.useState(false), editModeActive = _a[0], setEditModeActive = _a[1];
    var activateEditMode = useCallback(function (e) {
        if (!disabled && !editModeActive && !isSelectingText()) {
            e.preventDefault();
            setEditModeActive(true);
        }
    }, [disabled, editModeActive]);
    var activateReadOnlyMode = useCallback(function () {
        setEditModeActive(false);
    }, []);
    return {
        editModeActive: editModeActive,
        activateEditMode: activateEditMode,
        activateReadOnlyMode: activateReadOnlyMode,
    };
};
//# sourceMappingURL=useEditModeToggle.js.map